(function () {
   'use strict';

   var AUTOPLAY_MS = 6000;

   function init() {
      var track = document.getElementById('homeHeroTrack');
      var dotsWrap = document.getElementById('homeHeroDots');
      var prevBtn = document.getElementById('homeHeroPrev');
      var nextBtn = document.getElementById('homeHeroNext');
      var section = document.querySelector('.home-hero');
      var controls = document.querySelector('.home-hero__controls');

      if (!track || !dotsWrap) return;

      var slides = track.querySelectorAll('[data-hero-slide]');
      if (!slides.length) return;

      var total = slides.length;
      var current = 0;
      var timer = null;
      var paused = false;

      function buildDots() {
         dotsWrap.innerHTML = '';
         // Com apenas 1 slide, esconde todo o bloco de controles (setas + dots).
         if (total <= 1) {
            if (controls) controls.hidden = true;
            return;
         }
         if (controls) controls.hidden = false;

         for (var i = 0; i < total; i++) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'home-hero__dot' + (i === 0 ? ' is-active' : '');
            dot.setAttribute('role', 'tab');
            dot.setAttribute('aria-label', 'Ir para banner ' + (i + 1));
            dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
            dot.dataset.index = String(i);
            dot.addEventListener('click', function () {
               goTo(parseInt(this.dataset.index, 10));
               restartAutoplay();
            });
            dotsWrap.appendChild(dot);
         }
      }

      function syncDots() {
         var dots = dotsWrap.querySelectorAll('.home-hero__dot');
         dots.forEach(function (dot, i) {
            var active = i === current;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-selected', active ? 'true' : 'false');
         });
      }

      function syncControlsTheme() {
         if (!controls) return;
         var active = slides[current];
         var isLight = active && active.classList.contains('home-hero__slide--light');
         controls.classList.toggle('home-hero__controls--light', !!isLight);
      }

      function goTo(index) {
         if (total <= 1) return;
         current = ((index % total) + total) % total;
         track.style.transform = 'translateX(-' + (current * 100) + '%)';
         syncDots();
         syncControlsTheme();

         slides.forEach(function (slide, i) {
            slide.setAttribute('aria-hidden', i === current ? 'false' : 'true');
         });
      }

      function next() {
         goTo(current + 1);
      }

      function prev() {
         goTo(current - 1);
      }

      function stopAutoplay() {
         if (timer) {
            clearInterval(timer);
            timer = null;
         }
      }

      function startAutoplay() {
         stopAutoplay();
         if (total <= 1 || paused) return;
         timer = setInterval(next, AUTOPLAY_MS);
      }

      function restartAutoplay() {
         stopAutoplay();
         startAutoplay();
      }

      buildDots();
      goTo(0);
      startAutoplay();

      if (prevBtn) {
         prevBtn.addEventListener('click', function () {
            prev();
            restartAutoplay();
         });
      }

      if (nextBtn) {
         nextBtn.addEventListener('click', function () {
            next();
            restartAutoplay();
         });
      }

      if (section) {
         section.addEventListener('mouseenter', function () {
            paused = true;
            stopAutoplay();
         });
         section.addEventListener('mouseleave', function () {
            paused = false;
            startAutoplay();
         });
         section.addEventListener('focusin', function () {
            paused = true;
            stopAutoplay();
         });
         section.addEventListener('focusout', function () {
            paused = false;
            startAutoplay();
         });
      }

      document.addEventListener('visibilitychange', function () {
         if (document.hidden) {
            stopAutoplay();
         } else {
            startAutoplay();
         }
      });

      track.addEventListener('keydown', function (e) {
         if (e.key === 'ArrowLeft') {
            prev();
            restartAutoplay();
         } else if (e.key === 'ArrowRight') {
            next();
            restartAutoplay();
         }
      });
   }

   if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
   } else {
      init();
   }
})();
